module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0116-mail-history/mail-history.component.css
// module id = ./src/app/a0116-mail-history/mail-history.component.css
// module chunks = main